import { renderTextWithLineBreaks } from "../../../../utils/textLineBreaks";
import { StyledTitleGradientCard } from "./BoxTitleGradientCard.styled";

type BoxTitleGradientCardProps = {
  title: string;
};

const BoxTitleGradientCard = ({ title }: BoxTitleGradientCardProps) => (
  <StyledTitleGradientCard>
    <div className="title-gradient-inner">
      <h2 className="title-gradient-text">
        {renderTextWithLineBreaks(title)}
      </h2>
    </div>
  </StyledTitleGradientCard>
);

export default BoxTitleGradientCard;
